var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredentials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.038,
    height: 13.033,
    viewBox: "0 0 13.038 13.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credentials",
    transform: "translate(-1903.742 -765.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M1916.538,775.588l-3.818-3.818a4.6,4.6,0,1,0-2.947,2.947l.526.526a.858.858,0,0,0,.618.258h.549v.438a.972.972,0,0,0,.97.971h.439v.548a.87.87,0,0,0,.251.609l.469.469a.813.813,0,0,0,.578.238h1.867a.743.743,0,0,0,.74-.74v-1.863A.824.824,0,0,0,1916.538,775.588Zm-3.222.183h-.721v-.719a.681.681,0,0,0-.681-.681h-.89l-.708-.708a.564.564,0,0,0-.619-.121,3.473,3.473,0,0,1-3.808-5.654l.024-.026a3.452,3.452,0,0,1,2.432-1h0a3.472,3.472,0,0,1,3.2,4.828.562.562,0,0,0,.12.62l3.983,3.984v1.348H1914.3l-.3-.3v-.891A.681.681,0,0,0,1913.316,775.771Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M1908.672,769.022a1.647,1.647,0,1,0,1.647,1.647A1.649,1.649,0,0,0,1908.672,769.022Zm.518,1.659a.517.517,0,1,1-.56-.518h.042A.518.518,0,0,1,1909.189,770.681Z",
    transform: "translate(-1.195 -1.194)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentials);
export default __webpack_public_path__ + "static/media/Credentials.cccc00578a23d88e341ad46a0c8dd586.svg";
export { ForwardRef as ReactComponent };